import {inject} from '@angular/core';
import {CanActivateFn} from '@angular/router';
import {UserProfileService} from '../services/api/user-profile.service';

export const MaintenanceModuleLicensedUserGuard: CanActivateFn = (): boolean => {
  return inject(UserProfileService).getLoggedInUser()?.license?.maintenance_module;
}
